import { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../../context/useUser";

interface Props {
  children: ReactNode;
}

const AdminRoute: FC<Props> = ({ children }) => {
  const { user } = useUser();
  if (!user || !(user.isAdmin || user.isStaff)) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};

export default AdminRoute;
